import React, { useState, useContext, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { message, Row, Col, Button, Table } from 'antd';
// custom components
import axios, { CancelToken } from 'axios';
import { Store } from 'antd/lib/form/interface';

import { EditButton } from '../../../components/DataInput';

import Search from './search';

// api
// types

import { getLabelRoles } from '../../../interfaces/Roles';
import { ISearchData } from './types';
import { topTitleContext } from '../../../contexts/TopTitle';
import useAxios from '../../../hooks/axios/useAxios';
import { MethodList } from '../../../interfaces/Method';

const ListAdmin: React.FC = () => {
    const [searchData, setSearchData] = useState<ISearchData>({
        email: '',
        role: '',
    });
    const [data, setData] = useState([]);
    const [stores, setStores] = React.useState<Store[]>([]);
    const [meta, setMeta] = useState({
        current_page: 1,
        last_page: 1,
        total: 0,
    });

    const { response, error, loading, fetch } = useAxios();
    const { fetch: fetchGetStores } = useAxios();

    const setCurrentPage = (value: number) => {
        setMeta((prev) => {
            return { ...prev, current_page: value };
        });
    };

    const { title, titleValue } = useContext(topTitleContext);
    const titlePage = 'Usuários';
    useEffect(() => {
        titleValue(titlePage);
        return () => {
            titleValue('');
        };
    }, [title]);

    const handleSetSearchData = ({ ...rest }: ISearchData) => {
        setCurrentPage(1);
        setSearchData({ ...rest });
    };

    const getAdmins = useCallback(
        (token: CancelToken) => {
            const params = {
                method: MethodList.GET,
                url: '/subusers',
                cancelToken: token,
                params: {
                    email: searchData.email,
                    role: searchData.role,
                    page: meta.current_page,
                },
            };
            fetch(params);
        },
        [searchData, meta.current_page],
    );

    const getStores = React.useCallback(async (token: CancelToken) => {
        try {
            const options = {
                method: MethodList.GET,
                url: 'store',
                cancelToken: token,
                params: {
                    perPage: 50,
                },
            };

            const response = await fetchGetStores(options);
            if (response?.data.data.length > 0) {
                setStores([...response?.data.data]);
            }
        } catch (error: unknown) {
            if (axios.isAxiosError(error) && error.response?.status !== 401) {
                message.error('Um erro inesperado ocorreu');
            }
        }
    }, []);

    useEffect(() => {
        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        getStores(source.token);
        return () => {
            setStores([]);
            source.cancel('Request Cancelada');
        };
    }, [getStores]);

    useEffect(() => {
        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        getAdmins(source.token);
    }, [getAdmins]);

    useEffect(() => {
        if (response?.config?.method === 'get' && response?.data) {
            setData(response.data?.data);
            setMeta(response.data?.meta);
        }

        return () => {
            setData([]);
            setMeta({
                current_page: 1,
                last_page: 1,
                total: 0,
            });
        };
    }, [response]);

    useEffect(() => {
        if (error?.response) {
            const { errors } = error.response?.data;
            errors?.forEach((error: string) => message.error(error));
        } else if (error) {
            message.error(
                'Um erro inesperado aconteceu, tente novamente mais tarde',
            );
        }
    }, [error]);

    const getStoresNames = React.useCallback(
        (subStores: any[]) => {
            if (subStores.length === 1) {
                return subStores?.[0]?.store?.name;
            }
            if (subStores.length === stores.length) {
                return 'Todas as lojas';
            }
            return 'Múltiplos';
        },
        [stores],
    );

    return (
        <Row style={{ padding: '0 1rem' }}>
            <Col span={24}>
                <Search setSearch={handleSetSearchData} />
                <Row style={{ paddingTop: '1.5rem' }}>
                    <Col xs={24} sm={8} md={8} lg={6} xl={6} xxl={4}>
                        <Link to="/shopmanagers/users/create">
                            <Button
                                className="default-btn"
                                type="primary"
                                style={{ width: '100%' }}
                            >
                                Cadastrar
                            </Button>
                        </Link>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '1.2rem', padding: '1rem 0' }}>
                        A pesquisa retornou {meta.total} administradore(s)
                    </Col>
                </Row>

                <Table
                    dataSource={data}
                    rowKey="id"
                    scroll={{ x: 'max-content' }}
                    loading={loading}
                    bordered
                    pagination={{
                        current: meta.current_page,
                        total: meta.last_page * 10,
                        onChange: (page) => {
                            setCurrentPage(page);
                        },
                    }}
                >
                    <Table.Column
                        title="E-mail"
                        dataIndex={['user', 'email']}
                        key="email"
                        ellipsis
                    />
                    <Table.Column
                        title="Status"
                        dataIndex={['user', 'is_confirmed']}
                        key="status"
                        ellipsis
                        width={150}
                        render={(value: string) =>
                            value ? 'Confirmada' : 'Não confirmada'
                        }
                    />
                    <Table.Column
                        title="Permissão de acesso à loja"
                        dataIndex="subStores"
                        key="roles"
                        ellipsis
                        width={200}
                        render={(value: any) => getStoresNames(value)}
                    />
                    <Table.Column
                        title="Permissão"
                        dataIndex="type"
                        key="roles"
                        ellipsis
                        width={150}
                        render={(value: any) => getLabelRoles(value)}
                    />
                    <Table.Column
                        title="Ação"
                        key="action"
                        align="center"
                        width={80}
                        fixed="right"
                        render={(value: any) => (
                            <EditButton
                                to="/shopmanagers/users/update"
                                id={value?.id}
                            />
                        )}
                    />
                </Table>
            </Col>
        </Row>
    );
};

export default ListAdmin;
